module.exports = __webpack_public_path__ + "static/media/photo-business-meeting.9e02cde6.jpg";